import { render } from "./AgingUp.vue?vue&type=template&id=0efb4042&scoped=true&ts=true&lang=pug"
import script from "./AgingUp.vue?vue&type=script&lang=ts"
export * from "./AgingUp.vue?vue&type=script&lang=ts"

import "./AgingUp.vue?vue&type=style&index=0&id=0efb4042&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./AgingUp.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/views/agingUp.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FAgingUp.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efb4042"]])

export default __exports__